export default {
    title: '{school} {grade}학년 {className}반 <span>({onlineCount}/{totalCount})</span>',
    onlineCount: '수업 참여 중 <span>({count}명)</span>',
    offlineCount: '미참여 <span>({count}명)</span>',
    selectedStudents: '{count}명 선택됨',
    giveStar: ({ values }: { values: { isAll: boolean } }) => {
        const { isAll } = values;

        if (isAll) {
            return '<span>모든 학생</span>에게 별 주기';
        }

        return '<span>별 주기</span>';
    },
    giveStarConfirm: '<strong>{label}</strong>에게 칭찬별을 줄까요?',
    comment: {
        '0': '참 잘했어요',
        '1': '적극적으로 참여했어요',
        '2': '친구들과 잘 협력해요',
        '3': '설명을 잘했어요',
        '4': '논리적으로 답했어요',
        '5': '표현력이 훌륭해요',
        '6': '발표를 잘했어요',
        '7': '독창적인 답변이에요',
        '8': '창의력이 돋보여요',
    },
};
